import { createContext, createElement, useContext } from 'react';
import { createInputManagerStore, InputsManagerStore } from 'modules/InputsManager/store';

// variables to persist store between different views
let inputsManagerStore: InputsManagerStore | null = null;
let _userId: string | undefined;
let _appId: string | undefined;

export const InputsManagerStoreCtx = createContext<InputsManagerStore>(null as unknown as InputsManagerStore);

export function useInputsManagerStore(): InputsManagerStore {
  return useContext(InputsManagerStoreCtx);
}

interface InputManagerStoreProviderProps {
  store: InputsManagerStore;
}

export function InputManagerStoreProvider(props: React.PropsWithChildren<InputManagerStoreProviderProps>): JSX.Element {
  return createElement(InputsManagerStoreCtx.Provider, { value: props.store }, props.children);
}

export function getOrCreateInputsManagerStoreSingleton({
  env,
  userOrOrgId,
  appId,
}: {
  env: CF.MSTEnvironment;
  userOrOrgId?: string;
  appId?: string;
}): InputsManagerStore {
  if (!inputsManagerStore || _userId !== userOrOrgId || _appId !== appId) {
    _userId = userOrOrgId;
    _appId = appId;
    inputsManagerStore = createInputManagerStore(env);
  }
  return inputsManagerStore;
}
